import { defineComponent as _defineComponent } from 'vue'
import Header from "@/components/sgre/Header.vue";
import Footer from "@/components/sgre/Footer.vue";
import Loading from "@/components/sgre/Loading.vue";
import ResponseData from "@/types/ResponseData";
import GradeDataService from "@/services/GradeDataService";
import { ref, onMounted, reactive, onUpdated } from "vue";
import { useRouter } from "vue-router";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const radio = ref("search_dom");
const isDomError = ref(false);
const isImpError = ref(false);
const isLoading = ref(false);
const submittedVinNo = ref("");
const notFoundVinNo = ref("");
const vinNo1 = ref("");
const vinNo2 = ref("");
const vinNo3 = ref("");

const isNot17digits = () => {
  if (radio.value === "search_imp" && vinNo3.value.length !== 17) {
    isImpError.value = true;
  }
};

const isNotSingleByteAlphanumeric = () => {
  if (radio.value === "search_dom") {
    if (
      vinNo1.value.match(/[^A-Z0-9]+$/) ||
      vinNo2.value.match(/[^A-Z0-9]+$/)
    ) {
      isDomError.value = true;
    }
  } else if (radio.value === "search_imp") {
    if (vinNo3.value.match(/[^A-Z0-9]+$/)) {
      isImpError.value = true;
    }
  }
};

const isEmptyVinNo = () => {
  if (radio.value === "search_dom") {
    if (vinNo1.value === "" || vinNo2.value === "") {
      isDomError.value = true;
    }
  } else if (radio.value === "search_imp") {
    if (vinNo3.value === "") {
      isImpError.value = true;
    }
  }
};

const validations = () => {
  clearErrors();
  isNotSingleByteAlphanumeric();
  isEmptyVinNo();
  isNot17digits();
  if (isDomError.value === true || isImpError.value === true) {
    isLoading.value = false;
  }
};

const getGradeInfo = (vinNo) => {
  GradeDataService.getGradeInfo(vinNo)
    .then(async (response: ResponseData) => {
      const gradeInfo = response.data[0];
      store.dispatch("setVinNo", gradeInfo.vinNo);
      store.dispatch("setTypeName", gradeInfo.typeName);
      store.dispatch("setSaleModel", gradeInfo.saleModel);
      store.dispatch("setGrade", gradeInfo.grade);
      store.dispatch("setEngine", gradeInfo.engine);
      store.dispatch("setTurbo", gradeInfo.turbo);
      store.dispatch("setDriveSys", gradeInfo.driveSys);
      store.dispatch("setTransmission", gradeInfo.transmission);
      store.dispatch("setEDB", gradeInfo.EDB);
      store.dispatch("setAirbag", gradeInfo.airbag);
      store.dispatch("setOnsaleDate", gradeInfo.onsaleDate);
      isLoading.value = false;
      await router.push("/Result");
    })
    .catch(async (e: Error) => {
      console.log(e);
      store.dispatch("setNotFoundVinNo", vinNo);
      isLoading.value = false;
      await router.push("/NotFound");
    });
};

const submit = () => {
  isLoading.value = true;
  validations();
  if (radio.value === "search_dom" && !isDomError.value) {
    submittedVinNo.value = vinNo1.value + "-" + vinNo2.value;
    getGradeInfo(submittedVinNo.value);
  } else if (radio.value === "search_imp" && !isImpError.value) {
    submittedVinNo.value = vinNo3.value;
    getGradeInfo(submittedVinNo.value);
  }
};

const clearVinNo = () => {
  vinNo1.value = "";
  vinNo2.value = "";
  vinNo3.value = "";
};

const clearErrors = () => {
  isDomError.value = false;
  isImpError.value = false;
};

const vinNo1ToUppercase = (vinNo) => {
  vinNo = vinNo.toUpperCase();
  vinNo1.value = vinNo;
};

const vinNo2ToUppercase = (vinNo) => {
  vinNo = vinNo.toUpperCase();
  vinNo2.value = vinNo;
};

const vinNo3ToUppercase = (vinNo) => {
  vinNo = vinNo.toUpperCase();
  vinNo3.value = vinNo;
};

const openOldImage = () => {
  window.open("kei_old.gif");
};

const openNewImage = () => {
  window.open("kei_new.gif");
};

const openKogataImage = () => {
  window.open("kogata.gif");
};

const __returned__ = { router, radio, isDomError, isImpError, isLoading, submittedVinNo, notFoundVinNo, vinNo1, vinNo2, vinNo3, isNot17digits, isNotSingleByteAlphanumeric, isEmptyVinNo, validations, getGradeInfo, submit, clearVinNo, clearErrors, vinNo1ToUppercase, vinNo2ToUppercase, vinNo3ToUppercase, openOldImage, openNewImage, openKogataImage, Header, Footer, Loading }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})